import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import styled from 'styled-components';

const StyledFormGroup = styled(Form.Group)`
  margin-bottom: 1.25rem;

  .form-label {
    font-weight: 500;
    color: #495057;
    margin-bottom: 0.5rem;
  }

  .form-control, .form-select {
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e0e0e0;
    transition: all 0.3s ease;

    &:focus {
      border-color: #4b6cb7;
      box-shadow: 0 0 0 0.25rem rgba(75, 108, 183, 0.25);
    }

    &.is-invalid {
      border-color: #dc3545;
    }
  }
`;

const BasicInformation = ({ register, errors }) => (
    <>
        <h5 className="section-title">Candidate Details</h5>
        <Row>
            <StyledFormGroup as={Col} md="4">
                <Form.Label>First Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="text"
                    {...register('firstName')}
                    isInvalid={!!errors.firstName}
                    placeholder="Enter first name"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.firstName?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>

            <StyledFormGroup as={Col} md="4">
                <Form.Label>Middle Name</Form.Label>
                <Form.Control
                    type="text"
                    {...register('middleName')}
                    isInvalid={!!errors.middleName}
                    placeholder="Enter middle name"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.middleName?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>

            <StyledFormGroup as={Col} md="4">
                <Form.Label>Last Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="text"
                    {...register('lastName')}
                    isInvalid={!!errors.lastName}
                    placeholder="Enter last name"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.lastName?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>

        </Row>

        <Row>
            <StyledFormGroup as={Col} md="6">
                <Form.Label>Date of Birth <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="date"
                    {...register('dob')}
                    isInvalid={!!errors.dob}
                    placeholder="Enter Date of Birth"
                />
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.dob?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>

            <StyledFormGroup as={Col} md="6">
                <Form.Label>Gender<span className="text-danger">*</span></Form.Label>
                <Form.Select 
                    {...register("gender")}
                    isInvalid={!!errors.gender} >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    </Form.Select>
                <Form.Control.Feedback type="invalid" className="d-flex align-items-center">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    {errors.gender?.message}
                </Form.Control.Feedback>
            </StyledFormGroup>
        </Row>
    </>
);

export default BasicInformation;